"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutocomplete = useAutocomplete;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/**
 * @param {HTMLElement} element
 */
function useAutocomplete(element) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAutofill = _useState2[0],
      setIsAutofill = _useState2[1];

  var onAnimationStart = function onAnimationStart(e) {
    if (e.animationName.includes('onautofillstart')) {
      setIsAutofill(true);
    } else {
      setIsAutofill(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (element) {
      element.addEventListener('animationstart', onAnimationStart, true);
    }

    return function () {
      if (element) {
        element.removeEventListener('animationstart', onAnimationStart, true);
      }
    };
  }, [element]);
  return {
    isAutofill: isAutofill
  };
}